// Service Request types and visual metadata. Used by IncidentPanel,
// ServiceRequestModal, and the wizard's optional SR section.
import {
  Scissors,
  Wrench,
  Ruler,
  ScanLine,
  FlaskConical,
  Plane,
  PackagePlus,
  PackageMinus,
  RefreshCcw,
  HelpCircle,
} from "lucide-react";

export const SR_TYPES = [
  { id: "sorting", labelHu: "Válogatás", labelEn: "Sorting", Icon: Scissors, color: "#f3b14a" },
  { id: "engineering", labelHu: "Mérnöki támogatás", labelEn: "Engineering", Icon: Wrench, color: "#9ec3ec" },
  { id: "cmm_measurement", labelHu: "CMM mérés", labelEn: "CMM measurement", Icon: Ruler, color: "#c89adb" },
  { id: "3d_scanning", labelHu: "3D szkennelés", labelEn: "3D scanning", Icon: ScanLine, color: "#85e3c2" },
  { id: "material_testing", labelHu: "Anyagvizsgálat", labelEn: "Material testing", Icon: FlaskConical, color: "#ff9eb0" },
  { id: "sonderfahrt", labelHu: "Sonderfahrt", labelEn: "Special transport", Icon: Plane, color: "#E24B4A" },
  { id: "extra_loading", labelHu: "Extra felrakodás", labelEn: "Extra loading", Icon: PackagePlus, color: "#4ed084" },
  { id: "extra_unloading", labelHu: "Extra lerakodás", labelEn: "Extra unloading", Icon: PackageMinus, color: "#4ed084" },
  { id: "rework", labelHu: "Újramunkálás", labelEn: "Rework", Icon: RefreshCcw, color: "#f3b14a" },
  { id: "other", labelHu: "Egyéb", labelEn: "Other", Icon: HelpCircle, color: "#9aa1b3" },
];

export const SR_TYPE_BY_ID = Object.fromEntries(SR_TYPES.map((t) => [t.id, t]));

export const SR_STATUS_STYLE = {
  requested:    { color: "#9aa1b3", bg: "rgba(146,150,170,0.12)", border: "rgba(146,150,170,0.40)", label: "Requested" },
  acknowledged: { color: "#9ec3ec", bg: "rgba(24,95,165,0.16)",   border: "rgba(24,95,165,0.55)",   label: "Acknowledged" },
  in_progress:  { color: "#f3b14a", bg: "rgba(243,177,74,0.14)",  border: "rgba(243,177,74,0.50)",  label: "In Progress" },
  completed:    { color: "#4ed084", bg: "rgba(78,208,132,0.14)",  border: "rgba(78,208,132,0.50)",  label: "Completed" },
  cancelled:    { color: "#6b7388", bg: "rgba(107,115,136,0.10)", border: "rgba(107,115,136,0.30)", label: "Cancelled" },
};

export const SR_STATUSES = ["requested", "acknowledged", "in_progress", "completed", "cancelled"];

export const SR_PRIORITY_STYLE = {
  high:   { color: "#ff7e7c", label: "High" },
  medium: { color: "#f3b14a", label: "Medium" },
  low:    { color: "#85e3c2", label: "Low" },
};

export const formatDueDate = (iso) => {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleString(undefined, {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};
